import { Component, OnInit } from '@angular/core';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';

import { ActivatedRoute } from '@angular/router';
import { UrlDescargaApp } from '../../domain/UrlDescargaApp';

@Component({
	templateUrl: './DescargaApp.component.html'
})

export class DescargaAppComponent implements OnInit {

	spinner: HTMLElement;
	blockUI: HTMLElement;
	idEntidad: string;
	idQR: string;
	texto_mostrar = 'Redirigiendo a la pagina de descarga ...'
	constructor(
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private route: ActivatedRoute, )
	{
		console.log('*** DescargaAppComponent ***');
		
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';

		this.route.queryParams
		.subscribe(params => {
			this.idEntidad = params['idEntidad'];
			this.idQR = params['idQR'];

			this.redirigir();
		});

	}


	ngOnInit() {

	}

	redirigir() {
		const that = this;
		this.spinner.style.display = 'inherit';

		this.sws.wsObtenerUrlDescargaEverpaths(this.idEntidad, this.idQR).toPromise()
		.then(function (data) {

			if ((data.res === 1)) {

				const urlDescarga =  new UrlDescargaApp(data.urlDescargaApp);
				if (that.esIOS()){
					// Ocultamos Spinner
					that.spinner.style.display = 'none';

					window.location.href = urlDescarga.Url_ios;
				}
				else if (that.esAndroid()){
					// Ocultamos Spinner
					that.spinner.style.display = 'none';
					
					window.location.href = urlDescarga.Url_android;
				}
				else {
					// Ocultamos Spinner
					that.spinner.style.display = 'none';
					that.texto_mostrar = 'ERROR: DISPOSITIVO NO SOTORTADO';
				}

			}
			else {
				// Ocultamos Spinner
				that.spinner.style.display = 'none';
				
			}

		})
		.catch(function (error) {
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
			that.texto_mostrar = 'ERROR: EXCEPCION';
		});
	}

	private esIOS(){
		const ua = navigator.userAgent;
		if (/iPhone|iPad|iPod/i.test(ua)){
			return true;
		}
		else {
			return false;
		}
	}

	private esAndroid(){
		const ua = navigator.userAgent;
		if (/Android/i.test(ua)){
			return true;
		}
		else {
			return false;
		}
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/DescargaApp/DescargaApp.component.ts